module.exports = __webpack_public_path__ + "static/media/logo.d2146edd.png";